import { FC } from 'react';
import { FoundationContextProvider } from '@clds/design-system-foundations';
import { DropdownMenuItemWithLink } from '../../DropdownMenuItem';
import { ApplicationsDropdownItemProps } from '../ApplicationsDropdownMenu.types';
import { MENU_ITEM_ICON_SIZE } from '../../../ApplicationWrapper.const';

export const ApplicationsDropdownItem: FC<ApplicationsDropdownItemProps> = ({
  analyticsMessage,
  analyticsAction,
  icon,
  name,
  description,
  rightSlot,
  href,
  target,
  ...rest
}) => (
  <DropdownMenuItemWithLink
    analyticsMessage={analyticsMessage}
    analyticsAction={analyticsAction}
    leftSlot={<FoundationContextProvider size={MENU_ITEM_ICON_SIZE}>{icon}</FoundationContextProvider>}
    rightSlot={rightSlot}
    href={href}
    secondaryContent={description}
    target={target}
    // eslint-disable-next-line
    // @ts-ignore
    menuItemProps={{ selectionVariant: 'subtle', size: 'md', ...rest }}
  >
    {name}
  </DropdownMenuItemWithLink>
);
